import "leaflet/dist/leaflet.css";
import React, { useEffect, useState } from "react";
import useLogout from "../../hooks/useLogout";
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import { useUserSession } from '../../hooks/useUserSession';
import Modal from 'react-modal';

export default function MainPage() {
    const user = useSelector((state) => state.user)
    useUserSession(user)
    const navigate = useNavigate();
    const logout = useLogout();

    // const signOut = async () => {
    //     await logout();
    //     navigate('/login');
    // }

    const [modalIsOpen, setIsOpen] = useState(false);

    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
        },
    };

    function openModal() {
        setIsOpen(true);
    }

    function closeModal() {
        setIsOpen(false);
    }

    const signOut = (event) => {
        event.preventDefault();
        sessionStorage.clear()
        window.location = '/login'
    }

    useEffect((event) => {
        const token = sessionStorage.getItem('token')
        console.log('data', user)
        fetch('https://cpf-insight.herokuapp.com/authen', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            },
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 'ok') {
                    // alert('authen success')
                } else {
                    alert('login failed')
                    sessionStorage.removeItem('token');
                    window.location = '/login'
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }, [])

    const menuItem = (name, link, image) => {
        return (
            <a className="menuitem" href={link}>
                <div className="menuitem-card">
                    <div className="menuitem-image">
                        <img className="analytic-bg" src={image} />
                    </div>
                    <div className="menuitem-title">
                        {name}
                    </div>
                </div>
            </a >
        )
    }

    const handleLogout = (event) => {
        event.preventDefault();
        sessionStorage.clear('token')
        window.location = '/login'
    }

    return (
        <div className="homepage">
            {/* <div className='navbar'>
                <img className="cpf-logo" src="/assets/cpf-logo.jpg" />
                <button className="logout-btn" onClick={handleLogout}>
                    Log out
                </button>
            </div> */}
            <div className='home-navbar'>
                <img className='home-navbar-logo' src="/assets/cpf-logo.jpg" />
                <div className='home-navber-middle'>
                    ข้อมูลเพื่อบริหารธุรกิจอาหารสัตว์บก
                </div>
                <div className='user-logo'>
                    <button className="avatar-btn" onClick={openModal}>k</button>
                </div>
                <Modal
                    isOpen={modalIsOpen}
                    onRequestClose={closeModal}
                    style={customStyles}
                    contentLabel="Example Modal"
                >
                    <div className='dialog'>
                        <div className='dialog-container'>
                            <div className='avatar-img'>
                                k
                            </div>
                            <div>
                                Fullstack Developer
                            </div>
                            <div>
                                Mr.Kittin Vatabutr
                            </div>
                            <div>
                                0819339621
                            </div>
                        </div>
                        <button className='logout-btn' variant="contained" onClick={signOut}>Logout</button>
                    </div>
                </Modal>
            </div>
            <div className="homepage-container">
                {/* <div className="home-title-container">
                    <div className="home-title">
                        ข้อมูลเพื่อบริหารธุรกิจอาหารสัตว์บก
                    </div>
                </div> */}
                <div className="menuitem-grid">
                    {menuItem("Global Market", '/global-market/global-feed-production', 'assets/global-market.png')}
                    {menuItem("Thailand Market", '/thailand-market/quantity-animal', 'assets/Thailand-market.jpg')}
                    {menuItem("News-Social", '/test', 'assets/social-media.jpg')}
                    {menuItem("วัตถุดิบ", '/material', 'assets/material.jpg')}
                    {menuItem("แนวโน้มราคาสินค้า", '/test', 'assets/pig-pic.jpg')}
                    {menuItem("คู่แข่งขัน", '/competitor', 'assets/industry.jpg')}
                    {menuItem("Feed Production", '/test', 'assets/feed-production.jpg')}
                    {menuItem("บริการลูกค้า", 'https://cpffarmsolutions.com/member', 'assets/customer-service.jpg')}
                    {menuItem("Performance", '/performance', 'assets/performance-target.jpg')}
                    {menuItem("i project monitoring", 'https://www.feed.iprojectmonitoring.gpbsapps.com/', 'assets/i-monitoring.jpg')}
                </div>
            </div>
            <footer>
                <img className='home-footer-logo' src="assets/BSDOstandard.png" />
                <div className='home-footer-title'>
                    Copyright © CPF War room. Business Strategy Development Office. 2022 - 2023 All Right Reserved
                </div>
            </footer>
        </div>
    );
}

